<app-modal
  title="{{ 'BUTTON.FILTERS' | translate }}"
  saveButtonName="{{ 'BUTTON.SAVE' | translate }}"
  [cancelButtonExists]="false"
  (save)="onSave()"
>
  <ng-container body>
    @if (filterOptions) {
      <main>
        <section class="fixed-width">
          <mat-checkbox
            [(ngModel)]="filterOptions.dontDisplayEmptyFolders"
            data-cy="tree-dont-display-empty-folders"
          >
            {{ 'TREE.DONT_DISPLAY_EMPTY_FOLDERS' | translate }}
          </mat-checkbox>
        </section>
      </main>
    }
  </ng-container>
</app-modal>
